var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClothesClassic(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 38,
    viewBox: "0 0 31 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.843 1l2.594 1.21.518.258L15.03 1l2.248.692v2.247l-.865 3.458.865 2.94 3.457 5.359 2.421 5.705 1.21 5.533v3.112l-.346 1.383-1.556.864-1.383-.345-1.383-1.902-.346 1.037-1.037.865-1.037.345-1.383-.864-.865-1.383-.519 1.037-1.556 1.21-1.556-.345-1.556-1.902-.864 1.902-1.556.345-1.037-.345-1.027-1.902-.357 1.037-1.21 1.21-2.075-.345-.691-1.384v-2.939l.691-3.976 1.038-3.458 1.729-3.976 2.593-4.15 1.556-3.63V5.84l-.691-2.94v-1.21L9.843 1z",
    stroke: "currentColor",
    strokeWidth: 0.308
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.604 2.36c-.782-.534-2.678-1.5-4.006-1.088-.306.115-.87.641-.687 1.832l.458 2.06c.381.993.881 3.332-.172 4.751-1.03 1.545-3.285 5.014-4.064 6.525-.954 1.908-2.777 6.777-3.28 11.218-.058.286-.173 1.317-.173 2.29M5.374 29.834a2.347 2.347 0 11-4.694 0",
    stroke: "currentColor",
    strokeWidth: 0.784,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.067 29.834a2.347 2.347 0 11-4.693 0",
    stroke: "currentColor",
    strokeWidth: 0.784
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.414 32.18a2.347 2.347 0 01-2.347-2.346M12.585 2.36c.783-.534 2.68-1.5 4.007-1.088.305.115.87.641.687 1.832l-.458 2.06c-.382.993-.881 3.332.172 4.751 1.03 1.545 3.285 5.014 4.064 6.525.953 1.908 2.777 6.777 3.28 11.218.058.286.172 1.317.172 2.29",
    stroke: "currentColor",
    strokeWidth: 0.784,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.816 29.834a2.347 2.347 0 104.693 0",
    stroke: "currentColor",
    strokeWidth: 0.784
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.424 29.834a.392.392 0 01.784 0h-.784zm-4.301 0h.392c0 1.079.875 1.954 1.954 1.954v.784a2.739 2.739 0 01-2.739-2.738h.393zm2.346 2.346v-.392c1.08 0 1.955-.875 1.955-1.954h.784a2.739 2.739 0 01-2.739 2.738v-.392z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.776 32.18a2.347 2.347 0 002.347-2.346M8.889 8.844c.872-.191 2.484.056 3.53 2.354M16.341 8.9c-.871-.19-2.876 0-3.922 2.298M9.673 9.237l-3.922 14.12M11.173 9.629l-.715 10.197M15.369 9.237l3.922 13.727M13.869 9.629l.715 10.197",
    stroke: "currentColor",
    strokeWidth: 0.784,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.335 5.707l2.593 1.21.519.258 2.074-1.468 2.248.691v2.248l-.865 3.458.865 2.939 3.458 5.36 2.42 5.705 1.21 5.532v3.112l-.345 1.384-1.556.864-1.383-.346-1.384-1.902-.345 1.038-1.038.864L22.77 37l-1.383-.864-.865-1.384-.518 1.038L18.447 37l-1.556-.346-1.556-1.902-.865 1.902-1.556.346-1.037-.346-1.027-1.902-.356 1.038L9.284 37l-2.075-.346-.692-1.383v-2.939l.692-3.977 1.037-3.457 1.729-3.977 2.593-4.15 1.556-3.63v-2.593l-.691-2.94v-1.21l1.902-.691z",
    stroke: "currentColor",
    strokeWidth: 0.308
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.095 7.067c-.782-.535-2.679-1.5-4.007-1.088-.305.114-.87.641-.686 1.832l.457 2.06c.382.992.882 3.331-.171 4.75-1.03 1.546-3.286 5.015-4.064 6.526-.954 1.908-2.777 6.776-3.281 11.218-.057.286-.172 1.316-.172 2.29M10.864 34.54a2.347 2.347 0 01-4.693 0",
    stroke: "currentColor",
    strokeWidth: 0.784,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.558 34.54a2.347 2.347 0 01-4.693 0",
    stroke: "currentColor",
    strokeWidth: 0.784
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.905 36.887a2.347 2.347 0 01-2.347-2.347M18.076 7.067c.782-.535 2.679-1.5 4.007-1.088.305.114.87.641.687 1.832l-.458 2.06c-.382.992-.882 3.331.171 4.75 1.03 1.546 3.286 5.015 4.064 6.526.954 1.908 2.778 6.776 3.281 11.218.058.286.172 1.316.172 2.29",
    stroke: "currentColor",
    strokeWidth: 0.784,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.307 34.54a2.347 2.347 0 004.693 0",
    stroke: "currentColor",
    strokeWidth: 0.784
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.914 34.54a.392.392 0 11.785 0h-.785zm-4.3 0h.392c0 1.08.875 1.955 1.954 1.955v.784a2.739 2.739 0 01-2.739-2.739h.392zm2.346 2.347v-.392c1.08 0 1.954-.875 1.954-1.955h.785a2.739 2.739 0 01-2.739 2.74v-.393z",
    fill: "currentColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.267 36.887a2.347 2.347 0 002.347-2.347M14.38 13.551c.872-.191 2.484.056 3.53 2.353M21.832 13.607c-.872-.191-2.876 0-3.922 2.298M15.165 13.943l-3.923 14.12M16.665 14.335l-.716 10.198M20.86 13.943l3.922 13.728M19.36 14.335l.715 10.198",
    stroke: "currentColor",
    strokeWidth: 0.784,
    strokeLinecap: "round"
  })));
}
export default SvgClothesClassic;